import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { AddOrEditAddressButton as AddOrEditAddressButtonUnified } from './EditAddressButton'
import { AddOrEditAddressButtonLegacy } from './EditAddressButtonLegacy'
import type { EditAddressButtonProps } from './EditAddressButton.type'

export { EditAddressButtons } from './EditAddressButton.type'
export type {
  AddOrEditAddressButtonType,
  EditAddressButtonProps,
} from './EditAddressButton.type'

export const AddOrEditAddressButton: React.FC<EditAddressButtonProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <AddOrEditAddressButtonUnified {...props} />
  ) : (
    <AddOrEditAddressButtonLegacy {...props} />
  )
}
